(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              
              // FIX 1: Re-ignite scripts for "Add to Cart" Quick Add
              const scripts = this.querySelectorAll('script');
              scripts.forEach((oldScript) => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              // FIX 2: Attach Desktop Grab & Swipe Engine to the newly loaded grid
              const slider = this.querySelector('.grid');
              if (slider) {
                let isDown = false;
                let startX;
                let scrollLeft;
                let isDragging = false;

                slider.addEventListener('mousedown', (e) => {
                  isDown = true;
                  isDragging = false;
                  slider.style.cursor = 'grabbing';
                  startX = e.pageX - slider.offsetLeft;
                  scrollLeft = slider.scrollLeft;
                });

                slider.addEventListener('mouseleave', () => {
                  isDown = false;
                  slider.style.cursor = 'grab';
                });

                slider.addEventListener('mouseup', () => {
                  isDown = false;
                  slider.style.cursor = 'grab';
                });

                slider.addEventListener('mousemove', (e) => {
                  if (!isDown) return;
                  e.preventDefault();
                  isDragging = true;
                  const x = e.pageX - slider.offsetLeft;
                  const walk = (x - startX) * 1.5; // Scroll speed
                  slider.scrollLeft = scrollLeft - walk;
                });

                // Prevent link clicks if the user was just dragging
                const items = slider.querySelectorAll('.grid__item');
                items.forEach(item => {
                  item.addEventListener('click', (e) => {
                    if (isDragging) {
                      e.preventDefault();
                    }
                  });
                });
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      // INCREASED ROOT MARGIN: Loads the recommendations much earlier to eliminate the delay
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 1200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
